// import React from "react";
// import { Box, Container, Grid } from "@mui/material";
// -------------- components ---------------
import DetailCard from "./components/DetailCard";
import DoctorsCharts from "./components/DoctorsCharts";
import InsuranceChart from "./components/InsuranceChart";
import DoctorsList from "./components/DoctorsList";

//------------ icons -------------
import WavesIcon from "@mui/icons-material/Waves";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import PaidIcon from "@mui/icons-material/Paid";
import { useQuery } from "react-query";
import { getDashboarDetails } from "./services";
import { useState } from "react";
import { getAllDoctors } from "../../PatientCare/PatientBooking/v1/services";
import useAuthentication from "../../hooks/useAuthentication";
import { Paper } from "@mui/material";
import ExtraDetails from "./components/ExtraDetails";
import usePopup from "@hooks/usePopup";
import { useNavigate } from "react-router-dom";
import moduleRoutes from "@routes/moduleRouteList";
import dashboardRouteList from "../routeList";

function MainDashboard() {
  const base = import.meta.env.BASE_URL;
  const { user } = useAuthentication();
  const [doctorsData, setDoctorsData] = useState<any[]>([]);
  const [pieChartData, setPieChartData] = useState<any>(null);
  const { showSnackbar } = usePopup();
  const navigate = useNavigate();
  const { data: dashboardData } = useQuery(
    ["getDashboarDetails", user],
    async () => await getDashboarDetails(user?.clinicId),
    {
      enabled: !!user,
      onSuccess: (result) => {
        const pieChartData = result?.response?.pieChartData[0] || [];
        setPieChartData(pieChartData);
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.responseMessage ||
            e?.response.message ||
            "Something went wrong please refresh !",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
      refetchOnWindowFocus: false,
    }
  );

  useQuery(
    ["getAllDoctorsIndashboard", user],
    async () => await getAllDoctors(user?.clinicId),
    {
      enabled: !!user,
      onSuccess: (data) => {
        if (data.responseIndicator === "success") {
          const doctorList =
            data?.response?.flatMap((item: any) => {
              if (item?.doctor?.length > 0) {
                return item.doctor.map((docItem: any) => ({
                  id: docItem.doctorId,
                  name: docItem.doctorName,
                  time:
                    docItem.timeslots?.length > 0
                      ? docItem.timeslots.find((slot: any) => {
                          return slot.dayId === new Date().getDay();
                        }) || null
                      : null,
                  department: item.departmentName,
                }));
              }
              return [];
            }) || []; // Fallback to empty array if data?.response is undefined

          setDoctorsData(doctorList);
        }
      },
      refetchOnWindowFocus: false,
    }
  );

  return (
    <main className="flex flex-col gap-4 flex-wrap h-fit px-3 pt-3">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <DetailCard
          title="Patient Registry"
          themeColor="primary"
          sx={{ height: "100%", cursor: "pointer" }}
          icon="GroupIcon"
          views={{
            daily: {
              // label: "Today",
              value: dashboardData?.response?.monthData?.totalPatients || 0, // Estimating today's new if not explicitly in sample
              subDetails: [
                {
                  label: "New patients (this month)",
                  value: dashboardData?.response?.monthData?.newPatients || 0,
                  color: "success.main",
                },
                {
                  label: "Existing patients",
                  value: dashboardData?.response?.monthData?.existingPatients || 0,
                },
              ],
            },
            weekly: {
              label: "Weekly",
              value: dashboardData?.response?.monthData?.totalPatientsWeekly || dashboardData?.response?.monthData?.totalPatients || 0,
              subDetails: [
                {
                  label: "New",
                  value: dashboardData?.response?.monthData?.newPatientsWeekly || 0,
                  color: "success.main",
                },
                {
                  label: "Existing",
                  value: dashboardData?.response?.monthData?.existingPatientsWeekly || 0,
                },
              ],
            },
            monthly: {
              label: "Monthly",
              value: dashboardData?.response?.monthData?.totalPatients || 0,
              subDetails: [
                {
                  label: "New",
                  value: dashboardData?.response?.monthData?.newPatients || 0,
                  color: "success.main",
                },
                {
                  label: "Existing",
                  value: dashboardData?.response?.monthData?.existingPatients || 0,
                },
              ],
            },
          }}
          handleClick={() => {
            navigate(
              `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.reception}?tab=3`
            );
          }}
        />
        <DetailCard
        calendarFilter={true}
          title="Encounters"
          themeColor="info"
          sx={{ height: "100%" }}
          icon="PersonAddIcon"
            handleClick={() => {
            navigate(
              `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.reception}?tab=2`
            );
          }}
          views={{
            daily: {
              label: "Today",
              value: dashboardData?.response?.monthData?.totalEncountersToday || 0,
              subDetails: [
                {
                  label: "Cash",
                  value: dashboardData?.response?.monthData?.totalCashEncountersToday || 0,
                },
                {
                  label: "Insurance",
                  value: dashboardData?.response?.monthData?.totalInsuranceEncountersToday || 0,
                  color: "info.main",
                },
              ],
            },
            weekly: {
              label: "Weekly",
              value: dashboardData?.response?.monthData?.totalEncountersWeekly || 0,
              subDetails: [
                {
                  label: "Cash",
                  value: dashboardData?.response?.monthData?.totalCashEncountersWeekly || 0,
                },
                {
                  label: "Insurance",
                  value: dashboardData?.response?.monthData?.totalInsuranceEncountersWeekly || 0,
                  color: "info.main",
                },
              ],
            },
            monthly: {
              label: "Monthly",
              value: dashboardData?.response?.monthData?.totalEncountersThisMonth || 0,
              subDetails: [
                {
                  label: "Cash",
                  value: dashboardData?.response?.monthData?.totalCashEncountersThisMonth || 0,
                },
                {
                  label: "Insurance",
                  value: dashboardData?.response?.monthData?.totalInsuranceEncountersThisMonth || 0,
                  color: "info.main",
                },
              ],
            },
          }}
        />
        <DetailCard
        calendarFilter={true}
          title="Bookings"
          themeColor="warning"
          sx={{ height: "100%" }}
          icon="AddCardIcon"
          handleClick={() => {
            navigate(
              `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.reception}?tab=1`
            );
          }}
          views={{
            daily: {
              label: "Today",
              value: dashboardData?.response?.monthData?.totalBookings || 0,
              subDetails: [
                {
                  label: "Confirmed",
                  value: dashboardData?.response?.monthData?.totalBookingsConfirmed || 0,
                },
                {
                  label: "Arrived",
                  value: dashboardData?.response?.monthData?.totalArrived || 0,
                  color: "success.main",
                },
                {
                  label: "No Show",
                  value: dashboardData?.response?.monthData?.totalNoShow || 0,
                  color: "error.main",
                },
              ],
            },
            weekly: {
              label: "Weekly",
              value: dashboardData?.response?.monthData?.totalBookingsWeekly || 0,
              subDetails: [
                {
                  label: "Confirmed",
                  value: dashboardData?.response?.monthData?.totalBookingsConfirmedWeekly || 0,
                },
                {
                  label: "Arrived",
                  value: dashboardData?.response?.monthData?.totalArrivedWeekly || 0,
                  color: "success.main",
                },
                {
                  label: "No Show",
                  value: dashboardData?.response?.monthData?.totalNoShowWeekly || 0,
                  color: "error.main",
                },
              ],
            },
            monthly: {
              label: "Monthly",
              value: dashboardData?.response?.monthData?.totalBookingsMonthly || 0,
              subDetails: [
                {
                  label: "Confirmed",
                  value: dashboardData?.response?.monthData?.totalBookingsConfirmedMonthly || 0,
                },
                {
                  label: "Arrived",
                  value: dashboardData?.response?.monthData?.totalArrivedMonthly || 0,
                  color: "success.main",
                },
                {
                  label: "No Show",
                  value: dashboardData?.response?.monthData?.totalNoShowMonthly || 0,
                  color: "error.main",
                },
              ],
            },
          }}
        />
      </div>

      <div className="grid md:lg:grid-cols-5 gap-3">
        <div className="sm:w-12/12 md:lg:col-span-3">
          <DoctorsCharts details={dashboardData?.response?.lineChartData} />
        </div>
        <div className="sm:w-12/12 md:lg:col-span-2">
          <InsuranceChart
            details={{
              claimedInsurance: pieChartData?.claimedInsurance ?? 0,
              rejectedClaim: pieChartData?.rejectedClaims ?? 0,
              activeInsurance: pieChartData?.activeInsurance ?? 0,
              submittedInsurance: pieChartData?.submittedInsurance ?? 0,
            }}
          />
        </div>
      </div>

      <div className="grid md:grid-cols-5 gap-3 pb-3">
        <Paper className="sm:w-full md:col-span-2 h-full">
          <ExtraDetails
            products={[
              {
                id: "1",
                inHouse: JSON.stringify(
                  dashboardData?.response?.otherDetails?.radiologyPatients ?? 0
                ),
                outHouse: JSON.stringify(
                  dashboardData?.response?.otherDetails?.outHouseRadPatients ??
                    0
                ),
                name: "Radiology details",
                active: true,
                Icon: WavesIcon,
                color: "info.main",
              },
              {
                id: "2",
                inHouse: JSON.stringify(
                  dashboardData?.response?.otherDetails?.labPatients ?? 0
                ),
                outHouse: JSON.stringify(
                  dashboardData?.response?.otherDetails?.outHouseLabPatients ??
                    0
                ),
                name: "Lab details",
                active: true,
                Icon: BiotechOutlinedIcon,
                color: "info.main",
              },
              {
                id: "3",
                inHouse: JSON.stringify(
                  dashboardData?.response?.otherDetails?.billedPatients ?? 0
                ),
                outHouse: "",
                name: "Billed patients",
                active: true,
                Icon: ReceiptLongIcon,
                color: "info.main",
              },
              {
                id: "4",
                inHouse: JSON.stringify(
                  dashboardData?.response?.otherDetails?.paidPatients ?? 0
                ),
                outHouse: "",
                name: "Paid patients",
                active: true,
                Icon: PaidIcon,
                color: "info.main",
              },
            ]}
            sx={{ height: "100%" }}
          />
        </Paper>
        <Paper
          className="sm:w-full md:col-span-3 overflow-y-scroll"
          style={{ maxHeight: "500px" }} // Set a specific height for the scrollable area
        >
          <DoctorsList orders={doctorsData} />
        </Paper>
      </div>
    </main>
  );
}

export default MainDashboard;